var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticStyle:{"width":"150px"}},[_c('b-badge',{staticClass:"status-badge text-container",style:({
      backgroundColor: _vm.getLightBackground(_vm.statusColor),
      color: _vm.statusName === 'N/A' ? '#000' : _vm.statusColor
    })},[_vm._v(" "+_vm._s(_vm.statusName)+" ")])],1)}
var staticRenderFns = []

export { render, staticRenderFns }